<template>
  <el-select 
    v-model="selectedValue"
    :style="{width: width}"
    placeholder="请选择票据类型"
    clearable
    filterable
  >
    <el-option
      v-for="item in billTypeList"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    />
  </el-select>
</template>

<script>
import requestTicket from '@/utils/requestTicket'

export default {
  name: 'BillTypeLov',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    width: {
      type: String,
      default: '150px'
    }
  },
  data() {
    return {
      billTypeList: [],
      selectedValue: this.value
    }
  },
  watch: {
    selectedValue(newVal) {
      this.$emit('callBack', this.billTypeList?.find(item => item.id === newVal))
    },
    value(newVal) {
      this.selectedValue = newVal
    }
  },
  mounted() {
    this.fetchBillTypeList()
  },
  methods: {
    async fetchBillTypeList() {
      try {
        const res = await requestTicket.post('/Ticketing/bill-type/findAll')
        this.billTypeList = res.data || []
      } catch (error) {
        console.error('获取票据类型列表失败:', error)
      }
    }
  }
}
</script>